import React from 'react';

export const arrow = (
  <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 100 100">
    <path
      d="M50 10.8c-21.6 0-39.2 17.6-39.2 39.2S28.4 89.2 50 89.2 89.2 71.6 89.2 50 71.6 10.8 50 10.8zm0 76.4c-20.5 0-37.2-16.7-37.2-37.2S29.5 12.8 50 12.8 87.2 29.5 87.2 50 70.5 87.2 50 87.2z"
      fill="currentColor"></path>
    <path
      d="M61.1 48.1L39.9 26.9c-.2-.2-.4-.3-.7-.3-.6 0-1 .4-1 1 0 .3.1.5.3.7l21.2 21.2c.3.3.3.7 0 .9L38.5 71.7c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3l21.2-21.2c1-1.1 1-2.7 0-3.8z"
      fill="currentColor"></path>
  </svg>
);

export const caret = (
  <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 96 120">
    <path
      fill="currentColor"
      d="M45.59 63.41a2 2 0 002.83 0l29-29a2 2 0 00-2.83-2.83L47 59.17 19.41 31.59a2 2 0 00-2.83 2.83z"></path>
  </svg>
);

export const close = (
  <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 100 125">
    <path d="M50 .003C22.43.003 0 22.431 0 50s22.43 49.997 50 49.997c27.572 0 50-22.428 50-49.997S77.572.003 50 .003zm0 94.226C25.611 94.229 5.769 74.389 5.769 50 5.769 25.613 25.611 5.772 50 5.772S94.231 25.613 94.231 50c0 24.389-19.842 44.229-44.231 44.229z"></path>
    <path d="M59.447 36.474L50 45.921l-9.447-9.448a2.884 2.884 0 10-4.079 4.079L45.921 50l-9.448 9.447a2.885 2.885 0 004.08 4.08L50 54.079l9.447 9.447a2.885 2.885 0 104.079-4.079L54.079 50l9.447-9.447a2.883 2.883 0 10-4.079-4.079z"></path>
  </svg>
);

export const closex = (
  <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" enableBackground="new 0 0 100 100" viewBox="0 0 100 125">
    <path
      fill="currentColor"
      d="M52.8 50l17.6 17.6-2.8 2.8L50 52.8 32.4 70.4l-2.8-2.8L47.2 50 29.6 32.4l2.8-2.8L50 47.2l17.6-17.6 2.8 2.8L52.8 50z"></path>
  </svg>
);

export const download = (
  <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" data-name="Layer 1" viewBox="0 0 24 30">
    <path d="M21 16.27a.75.75 0 00-.75.75v2.86a.37.37 0 01-.37.38H4.12a.37.37 0 01-.37-.37V17a.75.75 0 00-1.5 0v2.86a1.88 1.88 0 001.87 1.88h15.76a1.88 1.88 0 001.87-1.87V17a.75.75 0 00-.75-.73z"></path>
    <path d="M11.44 17h.07a.65.65 0 00.46.18.75.75 0 00.53-.18l4.5-4.5a.75.75 0 10-1.06-1.06l-3.22 3.22V3a.75.75 0 10-1.5 0v11.69L8.06 11.5A.75.75 0 007 12.56z"></path>
  </svg>
);

export const calendar = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <g>
      <path
        fill="rgb(0,1,58)"
        d="M18.33359375 32.91640625c-.03203125 0-.06328125 0-.0953125-.003125C17.875 32.88515625 17.5421875 32.7 17.325 32.40546875l-4.58359375-6.25c-.40859375-.55625-.28671875-1.33828125.2703125-1.746875.5546875-.40625 1.33828125-.28671875 1.746875.2703125l3.721875 5.075 8.553125-8.553125c.48828125-.48828125 1.2796875-.48828125 1.76796875 0s.48828125 1.2796875 0 1.76875L19.21875 32.5515625c-.2375.23359375-.55546875.36484375-.88515625.36484375z"
      />
      <path
        fill="rgb(0,1,58)"
        d="M4.58361816 40h30.83276368C37.9453125 40 40 37.9453125 40 35.41644287v-27.5c0-2.5281372-2.05541992-4.5828247-4.58361816-4.5828247H4.58361816C2.0546875 3.33361816 0 5.38830566 0 7.91644286v27.5C0 37.9453125 2.0546875 40 4.58361816 40zM2.5 7.91644287c0-1.1484375.93518066-2.0828247 2.08361816-2.0828247h30.83276368c1.1484375 0 2.08361816.9343872 2.08361816 2.0828247v27.5C37.5 36.56488037 36.56481934 37.5 35.41638184 37.5H4.58361816C3.43518066 37.5 2.5 36.56488037 2.5 35.41644287v-27.5z"
      />
      <path
        fill="rgb(0,1,58)"
        d="M38.75 15.83359375H1.25c-.68984375 0-1.25-.56015625-1.25-1.25s.56015625-1.25 1.25-1.25h37.5c.68984375 0 1.25.56015625 1.25 1.25s-.56015625 1.25-1.25 1.25z"
      />
      <path
        fill="rgb(0,1,58)"
        d="M9.58359375 10c-.68984375 0-1.25-.56015625-1.25-1.25v-7.5c0-.68984375.56015625-1.25 1.25-1.25s1.25.56015625 1.25 1.25v7.5c0 .68984375-.56015625 1.25-1.25 1.25z"
      />
      <path
        fill="rgb(0,1,58)"
        d="M30.41640625 10c-.68984375 0-1.25-.56015625-1.25-1.25v-7.5c0-.68984375.56015625-1.25 1.25-1.25s1.25.56015625 1.25 1.25v7.5c0 .68984375-.56015625 1.25-1.25 1.25z"
      />
    </g>
  </svg>
);
export const menu = (
  <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 100 100">
    <path
      fill="currentColor"
      d="M24 984.362v4h52v-4zm0 16v4h52v-4zm0 16v4h52v-4z"
      enableBackground="accumulate"
      overflow="visible"
      transform="translate(0 -952.362)"></path>
  </svg>
);

export const errorPageIcon = (
  <svg width="236" height="195" viewBox="0 0 236 195" fill="none">
    <path
      d="M0 98.227C0 110.885 4.94764 122.787 13.9342 131.746C22.9207 140.704 34.8606 145.636 47.5579 145.636H87.5934C88.7293 145.636 89.84 145.183 90.6478 144.378C91.4556 143.573 91.9099 142.491 91.9099 141.333V120.145C91.9099 118.308 90.4206 116.848 88.6031 116.848H73.0029C71.1602 116.848 69.6961 118.333 69.6961 120.145V123.441H47.5831C33.5985 123.441 22.2896 112.143 22.2896 98.227V97.4972C22.2896 83.5562 33.6237 72.2827 47.5831 72.2827H69.6961V78.926C69.6708 80.7378 71.1602 82.1974 72.9777 82.1974H88.5779C90.4206 82.1974 91.8847 80.7127 91.8847 78.9008V54.3909C91.8847 53.2585 91.4303 52.1513 90.6226 51.346C89.8148 50.5408 88.7293 50.0878 87.5681 50.0878H47.5579C34.8606 50.0878 22.9207 55.02 13.9342 63.9785C4.94764 72.9369 0 84.8396 0 97.4972"
      fill="#00013A"
    />
    <path
      d="M151.988 21.3755C150.903 20.7967 149.691 20.4948 148.48 20.4948C145.652 20.4948 143.078 22.0298 141.765 24.521L128.613 49.4336C126.67 53.1076 128.083 57.6874 131.794 59.6251C132.879 60.2039 134.091 60.5058 135.303 60.5058C138.13 60.5058 140.705 58.9708 142.017 56.4796L155.169 31.567C156.103 29.7803 156.305 27.742 155.699 25.8044C155.093 23.8919 153.781 22.3066 151.988 21.3755Z"
      fill="#00B1EB"
    />
    <path
      d="M109.025 18.2803C108.04 15.1096 105.137 12.9706 101.805 12.9706C101.048 12.9706 100.291 13.0965 99.5587 13.3229C95.5703 14.556 93.3236 18.8087 94.5606 22.7847L102.941 49.6601C103.926 52.8307 106.829 54.9697 110.161 54.9697C110.918 54.9697 111.675 54.8439 112.407 54.6174C114.351 54.0135 115.916 52.7049 116.875 50.9183C117.809 49.1316 118.011 47.0933 117.406 45.1557L109.025 18.2803Z"
      fill="#00B1EB"
    />
    <path
      d="M147.571 73.0628C148.555 76.2335 151.458 78.3724 154.79 78.3724C155.547 78.3724 156.305 78.2466 157.037 78.0201L183.996 69.6656C187.985 68.4326 190.231 64.1798 188.969 60.229C187.985 57.0583 185.082 54.9194 181.75 54.9194C180.993 54.9194 180.235 55.0452 179.503 55.2717L152.544 63.601C148.555 64.8341 146.334 69.0868 147.571 73.0628Z"
      fill="#00B1EB"
    />
    <path
      d="M172.032 194.052C184.729 194.052 196.669 189.12 205.655 180.162L206.185 179.633C215.172 170.675 220.12 158.772 220.12 146.114C220.12 133.457 215.172 121.554 206.185 112.596L177.863 84.4118C177.055 83.6066 175.969 83.1536 174.808 83.1536C173.672 83.1536 172.562 83.6066 171.754 84.4118L156.734 99.3845C155.447 100.668 155.447 102.782 156.734 104.065L167.765 115.062C169.053 116.345 171.173 116.345 172.461 115.062L174.808 112.722L190.459 128.323C200.329 138.163 200.329 154.142 190.459 164.006L189.929 164.535C180.059 174.374 164.029 174.374 154.134 164.535L138.483 148.933L143.204 144.227C144.517 142.919 144.517 140.83 143.204 139.521L132.173 128.525C130.885 127.241 128.765 127.241 127.478 128.525L110.11 145.863C109.303 146.668 108.848 147.75 108.848 148.908C108.848 150.04 109.303 151.147 110.11 151.953L138.408 180.162C147.394 189.12 159.334 194.052 172.032 194.052Z"
      fill="#00013A"
    />
  </svg>
);

export const edit = (
  <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" fill="none" viewBox="0 0 52 52">
    <circle cx="24.917" cy="27.083" r="24.417" stroke="#fff"></circle>
    <path
      fill="#fff"
      d="M15.166 32.32v4.513h4.513l13.311-13.31-4.513-4.514L15.166 32.32zm21.315-12.288c.469-.47.469-1.228 0-1.697l-2.817-2.816a1.199 1.199 0 00-1.697 0l-2.202 2.202 4.513 4.514 2.203-2.203z"></path>
  </svg>
);

export const blueIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="none" viewBox="0 0 21 21">
    <path
      fill="#00B1EB"
      d="M10.5.875A9.597 9.597 0 00.875 10.5a9.597 9.597 0 009.625 9.625 9.597 9.597 0 009.625-9.625A9.597 9.597 0 0010.5.875zm1.313 15.75H9.187v-7h2.626v7zM10.5 7.875c-.963 0-1.75-.787-1.75-1.75s.787-1.75 1.75-1.75 1.75.787 1.75 1.75-.787 1.75-1.75 1.75z"></path>
  </svg>
);

export const callIcon = (
  <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="17.5" cy="16.7322" rx="17.5" ry="16.7322" fill="#FF9E1B" />
    <path
      d="M13.9656 19.4319C11.2394 16.8152 8.93411 13.3484 8.22378 10.7947C8.05132 10.1729 8.12329 9.61936 8.44423 9.10234C9.15743 7.95053 10.886 7.34363 11.5564 7.14464L14.2873 10.8487L12.7624 12.67C12.7214 12.719 12.6929 12.7764 12.6793 12.8378C12.6657 12.8991 12.6673 12.9627 12.6839 13.0233C12.6943 13.0624 12.798 13.4201 13.2065 14.0772C13.6383 14.7709 14.4896 15.9196 16.0982 17.4576C16.1107 17.4696 16.1239 17.4807 16.1378 17.491C19.0664 20.2836 20.6741 20.7042 20.7386 20.7209C20.802 20.7365 20.8684 20.7378 20.9324 20.7247C20.9964 20.7115 21.0564 20.6843 21.1075 20.6452L23.0131 19.1878L26.797 21.7382L25.9787 22.916C25.9365 22.9766 25.9122 23.047 25.9086 23.1198C25.9049 23.1925 25.9219 23.2648 25.9579 23.329C25.9938 23.3932 26.0473 23.4469 26.1126 23.4843C26.178 23.5217 26.2527 23.5415 26.3289 23.5415C26.3991 23.5422 26.4685 23.5261 26.5305 23.4945C26.5926 23.463 26.6454 23.4172 26.6842 23.3611L27.7287 21.8572C27.7894 21.7698 27.8121 21.6631 27.7919 21.56C27.7716 21.4568 27.7101 21.3653 27.6204 21.3048L23.2433 18.3546C23.1686 18.3043 23.0788 18.2785 22.9875 18.2812C22.8961 18.2839 22.8082 18.3149 22.7369 18.3695L20.7697 19.8747C20.459 19.7437 20.1595 19.5892 19.8743 19.4128C19.2176 19.0198 18.1361 18.2616 16.6973 16.886C16.685 16.8742 16.672 16.8632 16.6583 16.853C15.135 15.3904 14.3347 14.3126 13.9314 13.6643C13.795 13.4496 13.6739 13.2264 13.5689 12.9961L15.1432 11.1146C15.2001 11.0464 15.2323 10.9624 15.235 10.8752C15.2376 10.788 15.2107 10.7023 15.1581 10.6311L12.0725 6.44537C12.0239 6.37931 11.9555 6.32878 11.8764 6.30037C11.7973 6.27195 11.7111 6.26696 11.629 6.28605C11.5136 6.31332 8.795 6.96238 7.7213 8.68824C7.28041 9.38937 7.17926 10.1698 7.41008 11.0012C8.15765 13.691 10.5663 17.3206 13.4036 20.0334C13.4133 20.0427 13.4234 20.0515 13.4339 20.0597C16.2681 22.7603 20.0486 25.0505 22.8526 25.7635C23.7305 25.9873 24.552 25.8826 25.2943 25.4536C26.4731 24.7716 27.9202 24.802 28.9822 25.5311L31.2891 27.1143C31.3606 27.1638 31.4467 27.1903 31.5349 27.19C31.6241 27.19 31.711 27.1623 31.783 27.112C31.8551 27.0618 31.9087 26.991 31.936 26.9098C31.9633 26.8286 31.963 26.7412 31.9351 26.6603C31.9071 26.5793 31.8531 26.5088 31.7806 26.4591L29.4737 24.8758C28.1374 23.9571 26.3252 23.9143 24.858 24.763C24.3114 25.0791 23.7266 25.1517 23.0691 24.9843C20.3868 24.303 16.743 22.0837 14.0017 19.4626C13.9903 19.4517 13.9782 19.4415 13.9656 19.4319Z"
      fill="white"
    />
  </svg>
);

export const ArrowLeft = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g id="Arrow_left">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.8775 1.95136C16.5351 2.27822 16.5225 2.82079 16.8494 3.16321L8.40039 12.0142L16.4357 20.8519C16.7541 21.2022 16.7283 21.7443 16.378 22.0628C16.0277 22.3812 15.4856 22.3554 15.1671 22.0051L6.5966 12.5765C6.29396 12.2437 6.30028 11.7335 6.61093 11.4081L15.6109 1.97954C15.9377 1.63711 16.4803 1.6245 16.8775 1.95136Z"
          fill="#000000"
        />
      </g>
    </svg>
  );
};

export const ArrowRight = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g id="Arrow_right">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.12249 1.95136C6.78006 2.27822 6.76744 2.82079 7.0943 3.16321L15.543 12.0142L7.50866 20.8519C7.19022 21.2022 7.21604 21.7443 7.56632 22.0628C7.91659 22.3812 8.45869 22.3554 8.77713 22.0051L17.3486 12.5765C17.6512 12.2437 17.6449 11.7335 17.3343 11.4081L8.33434 1.97954C8.00748 1.63711 7.46491 1.6245 7.12249 1.95136Z"
          fill="#000000"
        />
      </g>
    </svg>
  );
};


export const ArrowLeftWhite = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g id="Arrow_left">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.8775 1.95136C16.5351 2.27822 16.5225 2.82079 16.8494 3.16321L8.40039 12.0142L16.4357 20.8519C16.7541 21.2022 16.7283 21.7443 16.378 22.0628C16.0277 22.3812 15.4856 22.3554 15.1671 22.0051L6.5966 12.5765C6.29396 12.2437 6.30028 11.7335 6.61093 11.4081L15.6109 1.97954C15.9377 1.63711 16.4803 1.6245 16.8775 1.95136Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  );
};

export const ArrowRightWhite = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g id="Arrow_right">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.12249 1.95136C6.78006 2.27822 6.76744 2.82079 7.0943 3.16321L15.543 12.0142L7.50866 20.8519C7.19022 21.2022 7.21604 21.7443 7.56632 22.0628C7.91659 22.3812 8.45869 22.3554 8.77713 22.0051L17.3486 12.5765C17.6512 12.2437 17.6449 11.7335 17.3343 11.4081L8.33434 1.97954C8.00748 1.63711 7.46491 1.6245 7.12249 1.95136Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  );
};



export const ArrowLeftIcon = ({ fill = "#0057FF" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g id="Arrow_left" clipPath="url(#clip0_106_7734)">
      <g id="Union">
        <path
          d="M9.0765 5.20922C8.7976 4.93027 8.3453 4.93027 8.0664 5.20922C7.7874 5.48816 7.7874 5.94043 8.0664 6.21937L11.8668 10.0198L8.0466 14.1584C7.779 14.4483 7.7971 14.9002 8.087 15.1677C8.3768 15.4353 8.8287 15.4172 9.0963 15.1274L13.382 10.4845C13.6421 10.2028 13.6333 9.76603 13.3622 9.49493L9.0765 5.20922Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.2857 10C19.2857 15.1284 15.1284 19.2857 10 19.2857C4.87164 19.2857 0.714285 15.1284 0.714285 10C0.714285 4.87165 4.87164 0.714285 10 0.714285C15.1284 0.714285 19.2857 4.87165 19.2857 10ZM17.8571 10C17.8571 14.3394 14.3394 17.8572 10 17.8572C5.66061 17.8572 2.14285 14.3394 2.14285 10C2.14285 5.66063 5.66061 2.14287 10 2.14287C14.3394 2.14287 17.8571 5.66063 17.8571 10Z"
          fill={fill}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_106_7734">
        <rect width="20" height="20" fill="white" transform="matrix(1 0 0 1 0 0)" />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowUp = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Arrow_down">
        <path
          id="Vector 76 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.95136 16.8778C2.27822 17.2202 2.82079 17.2328 3.16321 16.9059L12.0142 8.45727L20.8519 16.4916C21.2022 16.81 21.7443 16.7842 22.0628 16.4339C22.3812 16.0836 22.3554 15.5416 22.0051 15.2231L12.5765 6.65169C12.2437 6.34909 11.7335 6.3553 11.4081 6.6659L1.97954 15.6659C1.63711 15.9928 1.6245 16.5353 1.95136 16.8778Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  );
};

export const ArrowDown = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Arrow_down">
        <path
          id="Vector 76 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.95136 7.12249C2.27822 6.78006 2.82079 6.76744 3.16321 7.0943L12.0142 15.543L20.8519 7.50866C21.2022 7.19022 21.7443 7.21604 22.0628 7.56632C22.3812 7.91659 22.3554 8.45869 22.0051 8.77713L12.5765 17.3486C12.2437 17.6512 11.7335 17.6449 11.4081 17.3343L1.97954 8.33434C1.63711 8.00748 1.6245 7.46491 1.95136 7.12249Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  );
};

